import React, { useRef } from "react";
import Layout from "../../layout/Layout";
import "animate.css";
import useInView from "../../components/useInView";
import background_devcentral from "../../assets/background_devcentral.jpg";

function DevCentral() {
  const refGit = useRef(null);
  const refSources = useRef(null);

  const inViewGit = useInView(refGit);
  const inViewSources = useInView(refSources);

  return (
    <Layout>
      <div className="pt-16 md:pt-20 bg-white">
        <div className="flex flex-col space-y-2 sm:space-y-10 mx-auto py-2 ">
          <div className="flex justify-center items-center pl-6 pr-6 pb-16 sm:pl-20 sm:pr-20 slg:pl-24 lg:pr-24 bg-white animate__animated animate__fadeIn">
            <div
              className="grid grid-cols-1 slg:grid-cols-2 max-w-6xl items-center mx-auto gap-12"
              id="aboutsection"
            >
              <img
                src={background_devcentral}
                alt="background_devcentral"
                className="w-full h-auto rounded-xl border border-gray-200"
              />

              <div className="flex flex-col justify-center items-center gap-8">
                <div
                  className={`bg-gray-50 p-6 rounded-xl shadow-md transform transition-transform duration-300 hover:scale-105 hidden lg:block ${
                    inViewGit ? "animate-fadeInFormView" : ""
                  }`}
                >
                  <p className="text-gray-700 text-md">
                    An all-in-one resource hub that brings together essential
                    resources, practical guides, and helpful tools for
                    developers. At{" "}
                    <span className="bg-black text-white font-semibold text-xs py-1 px-1 border border-gray-700 rounded-md">
                      DevCentral
                    </span>
                    , you'll find everything you need to improve your{" "}
                    <b>development workflow</b>, <b>tackle challenges</b>, and
                    stay ahead in the ever-evolving tech landscape.
                  </p>
                </div>
                <div
                  className={`bg-gray-50 p-6 rounded-xl shadow-md transform transition-transform duration-300 hover:scale-105 ${
                    inViewGit ? "animate-fadeInFormView" : ""
                  }`}
                >
                  <p className="text-gray-700 text-md">
                    As we continue to grow our mission is to create a unified
                    platform where developers can find all the <b>tools</b>,{" "}
                    <b>resources</b>, and <b>guides</b> they need in one place.
                    Whether it’s <b>coding shortcuts</b> for faster development,
                    <b>VS Code extensions</b> for a more efficient coding
                    environment, or <b>innovative tools</b> to streamline your
                    workflow, we’ve got you covered. At{" "}
                    <span className="bg-black text-white font-semibold text-xs py-1 px-1 border border-gray-700 rounded-md">
                      DevCentral
                    </span>
                    , we’re committed to expanding our network and adding new
                    features to help developers innovate more efficiently.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col justify-center items-center pb-24 pt-4 pl-8 pr-8 xs:pl-12 xs:pr-12 sm:pl-16 sm:pr-16 lg:pl-20 lg:pr-20 bg-gray-50">
            <p className="text-lg md:text-xl text-slate-600 text-center leading-normal xs:leading-normal md:leading-normal">
              {" "}
              Dive in, explore, and let <b>DevCentral</b> guide you on your
              journey to mastering Development!
            </p>
            <div className="grid grid-cols-1 items-stretch max-w-6xl mx-auto pt-24">
              <div className="grid grid-cols-1 xlg:grid-cols-2 gap-16 xl:gap-24 rounded-xl">
                {/* Sources Section */}
                <div
                  className="flex flex-col space-y-6 p-5 pb-0 rounded-2xl bg-black h-fit"
                  id="devtools"
                  ref={refSources}
                >
                  <div className="bg-white rounded-t-xl flex flex-col p-4 gap-3">
                    <div className="flex flex-col space-y-1">
                      <span className="text-lg lg:text-2xl font-semibold">
                        DevTools
                      </span>
                      <span className="text-sm font-normal">
                        Explore powerful tools that boost productivity, simplify
                        workflows, and solve real development challenges,
                        perfect for developers at any level.
                      </span>
                    </div>

                    <div className="flex flex-wrap gap-2 justify-center">
                      <a href="#sumly">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          Sumly
                        </button>
                      </a>
                      <a href="#cursor">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          Cursor
                        </button>
                      </a>
                      <a href="#tinypng">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          TinyPNG
                        </button>
                      </a>
                      <a href="#diffchecker">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          Diffchecker
                        </button>
                      </a>
                      <a href="#ioimageonline">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          IO IMAGEONLINE.CO
                        </button>
                      </a>
                      <a href="#aos">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          AOS - Animate on scroll
                        </button>
                      </a>

                      <a href="#uiball">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          UI Ball - LDRS
                        </button>
                      </a>
                      <a href="#uiverse">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          Uiverse
                        </button>
                      </a>
                      <a href="#useanimations">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          UseAnimations
                        </button>
                      </a>
                      <a href="#shadcn">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          ShadCN UI
                        </button>
                      </a>
                      <a href="#hyperui">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          HyperUI
                        </button>
                      </a>
                      <a href="#lucide">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          Lucide
                        </button>
                      </a>
                      <a href="#flowbite">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          Flowbite
                        </button>
                      </a>
                      <a href="#freepik">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          Freepik
                        </button>
                      </a>
                      <a href="#pexels">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          Pexels
                        </button>
                      </a>
                      <a href="#undraw">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          UnDraw
                        </button>
                      </a>
                      <a href="#drawio">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          Diagrams.net
                        </button>
                      </a>
                      <a href="#vocarro">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          Vocarro
                        </button>
                      </a>
                      <a href="#plagiarismremover">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          PlagiarismRemover
                        </button>
                      </a>
                      <a href="#mocki">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          Mocki
                        </button>
                      </a>
                      <a href="#notegpt">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          NoteGPT
                        </button>
                      </a>
                      <a href="#signalhire">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          SignalHire
                        </button>
                      </a>
                      <a href="#startearly">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          StartEarly
                        </button>
                      </a>
                      <a href="#magicui">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          Magic UI
                        </button>
                      </a>
                      <a href="#locofy">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          Locofy
                        </button>
                      </a>
                      <a href="#toolify">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          Toolify
                        </button>
                      </a>
                      <a href="#linkedintextformatter">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          LinkedIn Text Formatter
                        </button>
                      </a>
                      <a href="#giftofspeed">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          GiftOfSpeed
                        </button>
                      </a>
                    </div>

                    <ul
                      className={`w-full h-80 overflow-y-scroll bg-white pl-2 pr-2 rounded-xl transform transition-transform duration-300 list-disc scrollbar-custom ${
                        inViewSources ? "animate-fadeInFormView" : ""
                      }`}
                    >
                      <li className="text-gray-700 text-md p-2 ml-4" id="sumly">
                        <a
                          href="https://chromewebstore.google.com/detail/honfjipamlobaeefcpggckeghjpolmjj?utm_source=item-share-cb"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>Sumly</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Sumly is an all-in-one Chrome extension to instantly
                        summarize content, enhance resumes with ATS fixes,
                        e-sign PDFs offline, add sticky notes to webpages, and
                        convert currencies in one click, supporting 19+
                        languages and a lot more.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="cursor"
                      >
                        <a
                          href="https://cursor.com/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>Cursor</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Cursor is an AI-powered code editor built on VS Code.
                        You can easily install it and sync your projects. It
                        helps fix bugs, complete tasks, and understand code
                        using plain English, perfect for both beginners and
                        pros.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="tinypng"
                      >
                        <a
                          href="https://tinypng.com/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>TinyPNG</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Compress PNG and JPEG images to make them smaller
                        without significantly impacting their appearance.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="diffchecker"
                      >
                        <a
                          href="https://www.diffchecker.com/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>Diffchecker</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Diffchecker is an online and desktop tool used to
                        quickly compare text, code, documents, or images and
                        highlight differences between two versions. It helps to
                        spot changes like additions, deletions, syntax
                        highlighting, real-time merging, and AI explanations.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="ioimageonline"
                      >
                        <a
                          href="https://round-corner.imageonline.co/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>IO IMAGEONLINE.CO</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Modify image corners to make them smoother or rounded.
                      </li>
                      <li className="text-gray-700 text-md p-2 ml-4" id="aos">
                        <a
                          href="https://michalsnik.github.io/aos/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>AOS - Animate on scroll</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : JavaScript library for adding scroll animations to
                        elements as they come into view.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="uiball"
                      >
                        <a
                          href="https://uiball.com/ldrs/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>UI Ball - LDRS</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Free, open-source loaders and spinners offering a
                        variety of visually appealing and customizable loading
                        animations.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="uiverse"
                      >
                        <a
                          href="https://uiverse.io/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>Uiverse</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Uiverse.io is a free, community-driven library of
                        stylish UI components like buttons, cards, and loaders.
                        You can easily browse and copy elements in HTML/CSS,
                        Tailwind, React, or Figma formats to use directly in
                        your projects.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="useanimations"
                      >
                        <a
                          href="https://useanimations.com/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>UseAnimations</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Free, customizable CSS animations such as hover
                        effects, button animations, page load animations, icon
                        animations and many more.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="shadcn"
                      >
                        <a
                          href="https://ui.shadcn.com/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>ShadCN UI</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Collection of high-quality, customizable UI components
                        such as forms, modals, dialogs, dropdowns, tables, date
                        picker, sliders, toast notifications and many more,
                        built with React and Tailwind CSS.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="lucide"
                      >
                        <a
                          href="https://lucide.dev/icons/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>Lucide</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Lucide.dev is a free, open-source icon library with
                        over 1,600 crisp, customizable SVG icons. You can browse
                        and copy icons in various formats like SVG, React, Vue,
                        Svelte, and more, perfect for web and app projects.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="hyperui"
                      >
                        <a
                          href="https://www.hyperui.dev/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>HyperUI</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Collection of beautifully designed, fully responsive
                        UI components and templates built with Tailwind CSS. It
                        provides a wide range of pre-built components such as
                        buttons, cards, navigation menus, forms, modals, and
                        more, which can be easily integrated into your web
                        projects.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="flowbite"
                      >
                        <a
                          href="https://flowbite.com/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>Flowbite</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Open-source UI component library providing a wide
                        variety of pre-built components such as buttons,
                        navigation bars, modals, tables, and more, all crafted
                        with Tailwind CSS for ease of customization and
                        integration.
                      </li>

                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="freepik"
                      >
                        <a
                          href="https://www.freepik.com/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>Freepik</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Freepik offers a wide collection of high-quality
                        graphics, including illustrations, photos, and 3D
                        images.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="pexels"
                      >
                        <a
                          href="https://www.pexels.com/search/videos/360/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>Pexels</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Provides free 360-degree videos for personal and
                        commercial use, with no attribution required. Download
                        and use these videos in projects such as websites, apps,
                        or presentations.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="undraw"
                      >
                        <a
                          href="https://undraw.co/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>UnDraw</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Collection of free, customizable illustrations for
                        personal and commercial projects without attribution.
                        Customize the color of the illustrations to match your
                        project’s theme and download them in various formats
                        like SVG and PNG.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="drawio"
                      >
                        <a
                          href="https://www.drawio.com/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>Diagrams.net</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Free, web-based tool for creating diagrams,
                        flowcharts, and mind maps. Use it to design everything
                        from simple sketches to complex system architectures.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="vocarro"
                      >
                        <a
                          href="https://vocaroo.com/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>Vocarro</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Vocaroo is a free, browser-based voice recorder that
                        lets you quickly record audio and share it via link, QR
                        code, or download as MP3—no signup needed.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="plagiarismremover"
                      >
                        <a
                          href="https://www.plagiarismremover.net/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>PlagiarismRemover</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : PlagiarismRemover.net is a free AI tool that rewrites
                        text to remove plagiarism while keeping the original
                        meaning. Just paste your text, choose a mode, and get a
                        clean version instantly, no signup needed.
                      </li>
                      <li className="text-gray-700 text-md p-2 ml-4" id="mocki">
                        <a
                          href="https://mocki.io/fake-json-api"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>Mocki</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Mocki.io is a free tool to create fake JSON and
                        GraphQL APIs for testing and development. Just define
                        your response and get a shareable endpoint, no backend
                        needed.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="notegpt"
                      >
                        <a
                          href="https://notegpt.io/ai-diagram-generator"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>NoteGPT</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : NoteGPT's AI Diagram Generator lets you turn plain
                        text into flowcharts, graphs, and diagrams instantly.
                        It's free, browser-based, and requires no sign-in—just
                        paste text, generate, and download.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="signalhire"
                      >
                        <a
                          href="https://signalhire.com/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>SignalHire</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : SignalHire is a contact-finding tool that helps you
                        discover verified email addresses and phone numbers from
                        platforms like LinkedIn, GitHub, and Twitter. It offers
                        a browser extension and limited free credits.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="startearly"
                      >
                        <a
                          href="https://www.startearly.ai/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>StartEarly</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : StartEarly.ai is an AI tool that helps developers
                        generate and validate unit tests directly in their IDE,
                        improving code quality and coverage with minimal effort.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="magicui"
                      >
                        <a
                          href="https://magicui.design/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>Magic UI</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Magic UI offers 150+ free, open-source animated
                        components and effects built with React, TypeScript,
                        Tailwind CSS, and Framer Motion. It's a perfect
                        companion to shadcn/ui, making it easy to add polished,
                        interactive UI elements to your projects.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="locofy"
                      >
                        <a
                          href="https://www.locofy.ai/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>Locofy</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Locofy.ai is an AI tool that converts Figma or XD
                        designs into clean, responsive code (React, Next.js,
                        HTML/CSS, etc.), speeding up front-end development with
                        live previews and export options.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="toolify"
                      >
                        <a
                          href="https://toolify.ai/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>Toolify</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : Toolify.ai is a free AI tools directory where you can
                        explore and discover thousands of AI apps across
                        categories like writing, design, coding, and more—no
                        sign-up needed.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="linkedintextformatter"
                      >
                        <a
                          href="https://www.linkedin-makeover.com/linkedin-text-formatter/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>LinkedIn Text Formatter</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : LinkedIn Text Formatter lets you style your LinkedIn
                        posts with bold, italics, and more using special
                        characters. Just type, format, copy, and paste, no
                        sign-up needed.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="giftofspeed"
                      >
                        <a
                          href="https://giftofspeed.com/base64-encoder"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>GiftOfSpeed</b>
                          <span className="inline-block align-top -translate-y-2 transform ml-[0.1rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : GiftOfSpeed's Base64 Encoder is a simple web tool that
                        converts any file into a Base64-encoded string—ideal for
                        embedding images, fonts, or scripts directly into HTML
                        or CSS.
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Git commands Section  */}
                <div
                  className="flex flex-col space-y-6 p-5 pb-0 h-fit rounded-2xl bg-black"
                  id="gitguide"
                  ref={refGit}
                >
                  <div className="bg-white rounded-t-xl flex flex-col p-4 gap-3 h-full">
                    <div className="flex flex-col space-y-1 ">
                      <div className="flex items-center space-x-2 text-xl sm:text-2xl font-semibold">
                        GitCommands
                      </div>
                    </div>
                    <div className="flex flex-wrap gap-2 justify-center">
                      <a href="#gitinit">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git init
                        </button>
                      </a>
                      <a href="#gitclone">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git clone
                        </button>
                      </a>
                      <a href="#gitlog">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git log
                        </button>
                      </a>
                      <a href="#gitdiff">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git diff
                        </button>
                      </a>

                      <a href="#gitbranch">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git branch
                        </button>
                      </a>
                      <a href="#gitcheckout">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git checkout
                        </button>
                      </a>
                      <a href="#gitcheckoutpreviousbranch">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git checkout -
                        </button>
                      </a>
                      <a href="#gitcheckoutnewbranch">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git checkout -b
                        </button>
                      </a>
                      <a href="#gitcheckoutdeletebranch">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git checkout -D
                        </button>
                      </a>
                      <a href="#gitadd">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git add
                        </button>
                      </a>
                      <a href="#gitcommit">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git commit
                        </button>
                      </a>
                      <a href="#gitpush">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git push
                        </button>
                      </a>
                      <a href="#gitpull">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git pull
                        </button>
                      </a>
                      <a href="#gitstash">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git stash
                        </button>
                      </a>
                      <a href="#gitreset">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git reset
                        </button>
                      </a>
                      <a href="#gitmerge">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git merge
                        </button>
                      </a>
                      <a href="#gitcherrypick">
                        <button className="bg-black hover:bg-white hover:text-black text-white font-semibold text-xs py-2 px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out w-full sm:w-auto">
                          git cherry-pick
                        </button>
                      </a>
                    </div>

                    <ul
                      className={`w-full h-80 overflow-y-scroll bg-white pl-2 pr-2 rounded-xl transform transition-transform duration-300 list-disc scrollbar-custom ${
                        inViewGit ? "animate-fadeInFormView" : ""
                      }`}
                    >
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitinit"
                      >
                        <a
                          href="https://docs.gitlab.com/ee/topics/git/commands.html#git-init"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git init</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To initialize a new Git repository in the current
                        folder.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitclone"
                      >
                        <a
                          href="https://docs.gitlab.com/ee/topics/git/commands.html#git-clone"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git clone repo_link</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To clone a remote repository into a new folder on your
                        local machine.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitlog"
                      >
                        <a
                          href="https://docs.gitlab.com/ee/topics/git/commands.html#git-log"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git log</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To display the commit history for the current branch.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitdiff"
                      >
                        <a
                          href="https://docs.gitlab.com/ee/topics/git/commands.html#git-diff"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git diff</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To view the differences between your local unstaged
                        changes and the latest version that you cloned or
                        pulled.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitbranch"
                      >
                        <a
                          href="https://www.atlassian.com/git/tutorials/using-branches"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git branch</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To list branches in your repository.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitcheckoutnewbranch"
                      >
                        <a
                          href="https://docs.gitlab.com/ee/topics/git/commands.html#git-checkout"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git checkout -b new_branch_name</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To create and switch to a new branch from master/main
                        or parent branch.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitcheckoutpreviousbranch"
                      >
                        <a
                          href="https://docs.gitlab.com/ee/topics/git/commands.html#git-checkout"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git checkout -</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To go to a previous branch.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitcheckoutdeletebranch"
                      >
                        <a
                          href="https://docs.gitlab.com/ee/topics/git/commands.html#git-checkout"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git checkout -D branch_name</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To delete a branch locally.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitcheckoutswitchbranch"
                      >
                        <a
                          href="https://docs.gitlab.com/ee/topics/git/commands.html#git-checkout"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git checkout branch_name</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To switch from one branch to another.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitaddall"
                      >
                        <a
                          href="https://docs.gitlab.com/ee/topics/git/commands.html#git-add"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git add .</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To stage all changes.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitcommit"
                      >
                        <a
                          href="https://docs.gitlab.com/ee/topics/git/commands.html#git-commit"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git commit -m "message"</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To commit staged changes.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitpush"
                      >
                        <a
                          href="https://docs.gitlab.com/ee/topics/git/commands.html#git-push"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git push origin branch_name</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To push both the branch and its commits from your
                        local repository to the remote repository named origin.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitpushforce"
                      >
                        <a
                          href="https://docs.gitlab.com/ee/topics/git/commands.html#git-push"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git push origin branch_name --force</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To forcefully push your local branch to the remote
                        repository, named origin.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitpull"
                      >
                        <a
                          href="https://docs.gitlab.com/ee/topics/git/commands.html#git-pull"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git pull origin branch_name</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To fetch changes from the remote repository and merge
                        them into your local branch.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitstash"
                      >
                        <a
                          href="https://www.w3schools.com/git/git_stash.asp"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git stash</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To temporarily save changes to switch to another
                        branch to work on something else but don’t want to
                        commit the changes.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitstashpop"
                      >
                        <a
                          href="https://www.w3schools.com/git/git_stash.asp"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git stash pop</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To re apply/pop stashed changes.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitresethard"
                      >
                        <a
                          href="https://docs.gitlab.com/ee/topics/git/commands.html#git-reset"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git reset --hard Head~n</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To reset your current branch's state to a previous
                        commit.
                        <p>
                          For example : HEAD~2 means two commits before the
                          current commit.
                        </p>
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitmerge"
                      >
                        <a
                          href="https://docs.gitlab.com/ee/topics/git/commands.html#git-merge"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git merge</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : To combine changes from different branches into the
                        current branch.
                      </li>
                      <li
                        className="text-gray-700 text-md p-2 ml-4"
                        id="gitcherrypick"
                      >
                        <a
                          href="https://www.geeksforgeeks.org/git/git-cherry-pick/"
                          target="_blank"
                          rel="noreferrer"
                          className="link_hover_effect"
                        >
                          <b>git cherry-pick</b>{" "}
                          <span className="inline-block align-top -translate-y-2 transform -ml-[0.2rem]">
                            {"\u2197"}
                          </span>
                        </a>
                        : git cherry-pick is used to apply specific commits from
                        one branch to another. For example, if you've merged
                        changes into the development branch and want those
                        changes to reflect in the stage environment, you can
                        create a new branch from stage, use{" "}
                        <b>git cherry-pick commit-hash</b> to apply the desired
                        commits, and then push the changes.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default DevCentral;
